module.exports = __webpack_public_path__ + "static/media/delete-icon.07ef99b2.svg";